import script from "./qrcode.vue?vue&type=script&lang=ts&setup=true"
export * from "./qrcode.vue?vue&type=script&lang=ts&setup=true"

import "./qrcode.vue?vue&type=style&index=0&id=79fd639f&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79fd639f"]])

export default __exports__